import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  /**
   * todo:
   * navigation sesuai routing
   * buat menus navigation jadi array
   */

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/attendance-management">
                <i className="bx bx-home-circle"></i>
                <span>勤怠管理</span>
              </Link>
            </li>
            <li>
              <Link className="nav-link" to="/orders">
                <i className="bx bx-food-menu"></i>
                <span>受注一覧</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-customize"></i>
                <span>振り分け</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/arrangement/bespoke">Bespoke/MTM</Link>
                </li>
                <li>
                  <Link to="/arrangement/rtw">RTW</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-list-check"></i>
                <span>検品</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/inspection/bespoke">Bespoke/MTM</Link>
                </li>
                <li>
                  <Link to="/inspection/rtw">RTW</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/production-amount">
                <i className="bx bx-book-bookmark"></i>
                <span>制作高</span>
              </Link>
            </li>
            <li>
              <Link to="/corporate-orders">
                <i className="bx bx-receipt"></i>
                <span>RTW法人受注</span>
              </Link>
            </li>
            <li>
              <Link to="/retail-list">
                <i className="bx bx-server"></i>
                <span>RTW小売一覧</span>
              </Link>
            </li>
            <li>
              <Link to="/order-sheet-creation">
                <i className="bx bx-calculator"></i>
                <span>オーダーシート作成</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-table"></i>
                <span>マスター管理</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/master/product-category">商品カテゴリー</Link>
                </li>
                <li>
                  <Link to="/master/product">商品マスター</Link>
                </li>
                <li>
                  <Link to="/master/specification">仕様マスター</Link>
                </li>
                <li>
                  <Link to="/master/dimension">寸法マスター</Link>
                </li>
                <li>
                  <Link to="/master/correction">補正マスター</Link>
                </li>
                <li>
                  <Link to="/master/rtw-season">RTWシーズンマスター</Link>
                </li>
                <li>
                  <Link to="/master/rtw-product">RTW商品マスター</Link>
                </li>
                <li>
                  <Link to="/master/rtw-handwritten-image">
                    RTW手書き画像マスター
                  </Link>
                </li>
                <li>
                  <Link to="/master/dough">生地マスター</Link>
                </li>
                <li>
                  <Link to="/master/fabric-trading-company">
                    生地商社マスター
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/enterprise-customer-management">
                <i className="bx bx-user-voice"></i>
                <span>取引先企業管理</span>
              </Link>
            </li>
            <li>
              <Link to="/direct-management-individual-customer-management">
                <i className="bx bx-user-plus"></i>
                <span>自社顧客管理</span>
              </Link>
            </li>
            <li>
              <Link to="/individual-customer-management">
                <i className="bx bx-user-check"></i>
                <span>取引先顧客管理</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-package"></i>
                <span>在庫管理</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/inventory-control/fabric-inventory-management">
                    生地在庫管理
                  </Link>
                </li>
                <li>
                  <Link to="/inventory-control/fabric-purchase-management">
                    生地仕入管理
                  </Link>
                </li>
                <li>
                  <Link to="/inventory-control/rtw-inventory-management">
                    RTW在庫管理
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/administrator">
                <i className="bx bx-user-circle"></i>
                <span>管理者</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
